export type OrganisationHierarchy = {
  id: string;
  organizationName: string;
  organizationNumber: string;
  parentId: string | null;
  children: OrganisationHierarchy[];
};

export const findTenantInHierarchy = (
  root: OrganisationHierarchy,
  tenantId: string
): OrganisationHierarchy | undefined => {
  if (root.id === tenantId) return root;
  for (const child of root.children) {
    const found = findTenantInHierarchy(child, tenantId);
    if (found) return found;
  }
  return undefined;
};

export const flattenTenantIds = (root: OrganisationHierarchy): string[] => {
  const ids: string[] = [root.id];
  for (const child of root.children) ids.push(...flattenTenantIds(child));
  return ids;
};
